import { isFunction } from '@dimjs/lang';
import { classNames } from '@dimjs/utils';
import { hooks } from '@wove/react';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { ModalDrawer, ModalDrawerProps } from '../../modal-drawer';
import { bodyAppendDivElement, BodyAppendDivElementProps, removeBodyChild } from '../../utils';

type DialogDrawerProps = ModalDrawerProps & { children: JSX.Element };

const ModalRender = (props: DialogDrawerProps & BodyAppendDivElementProps) => {
  const { elementId, ...otherProps } = props;
  const [visible, setVisible] = useState(false);

  const onClose = hooks.useCallbackRef(() => {
    if (props.onClose) {
      props.onClose();
    } else {
      setVisible(false);
    }
  });

  useEffect(() => {
    setVisible(true);
    window['dialogDrawerClose'] = () => {
      setVisible(false);
    };
  }, []);

  const onAfterClose = hooks.useCallbackRef(() => {
    removeBodyChild(`#${elementId}`);
  });

  return (
    <ModalDrawer
      {...otherProps}
      visible={visible}
      onAfterClose={onAfterClose}
      getContainer={props.divElement}
      onClose={onClose}
      destroyOnClose={true}
      className={classNames('v-dialog-drawer', props.className)}
    >
      {props.children}
    </ModalDrawer>
  );
};

export const dialogDrawer = {
  show: (props: DialogDrawerProps) => {
    const { divElement, elementId } = bodyAppendDivElement();
    ReactDOM.render(<ModalRender {...props} divElement={divElement} elementId={elementId} />, divElement);
  },
  close: () => {
    const dialogDrawerClose = window['dialogDrawerClose'];
    if (dialogDrawerClose && isFunction(dialogDrawerClose)) {
      window['dialogDrawerClose']();
      window['dialogDrawerClose'] = null;
    } else {
      const element = document.querySelector('.v-dialog-spinner');
      if (element) {
        const elementParent = document.querySelector('.v-dialog-spinner')?.parentNode;
        document.body.removeChild(elementParent as Node);
      }
    }
  },
};
